import React from 'react'
import { Select, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl, outputMoney} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './no-nmedical-devices.module.less'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class CooperationPolicy extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      detailsData: null
    }
  }

  componentDidMount () {
    let {detailsData} = this.state
    detailsData = this.props.detailsData
    this.setState({
      detailsData
    })
  }

  componentWillReceiveProps (nextprops) {
    let {detailsData} = this.state
    detailsData = nextprops.detailsData
    this.setState({
      detailsData
    })
  }

  render () {
    let {detailsData} = this.state
    return (
      <div>
        <div style={{ display: 'flex', border: '1px solid #d9d9d9', paddingBottom: '24px' }}>
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', paddingLeft: '13%' }}>
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>账期：</span>
                <span  style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.period_day ? detailsData.item_info.period_day + '天' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>铺货金额：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.distribution_money ? detailsData.item_info.distribution_money + '元' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>有无返利：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.is_rebate === 1 ? '有' : '无' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利方式：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                {detailsData ? detailsData.item_info.rebate_type ? detailsData.item_info.rebate_type === 'reduce' ? '减账' : detailsData.item_info.rebate_type === 'goods' ? '货返' : '现金打款' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利点数：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.rebate_point ? detailsData.item_info.rebate_point + '%' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利基数：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                {detailsData ? detailsData.item_info.rebate_base ? detailsData.item_info.rebate_base === 'no_tax' ? '未税' : '含税' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>结算价：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.purchase_price ? detailsData.item_info.purchase_price + '元' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>促销价：</span>
                <span  style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.promotion_price ? detailsData.item_info.promotion_price + '元' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>毛利率：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.gross_rate ? outputMoney(detailsData.item_info.gross_rate * 10000 / 100) + '%' : '-' : '-'}
                </span>
              </section>


              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>毛利额：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.gross_money ? detailsData.item_info.gross_money + '元' : '-' : '-'}
                </span>
              </section>


              <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>返利成本：</span>
              <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                {detailsData ? detailsData.item_info.rebate_cost ? detailsData.item_info.rebate_cost  : '-' : '-'}
              </span>
            </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>供应商订货周期：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.order_cycle ? detailsData.item_info.order_cycle + '天' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>售后问题：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                {detailsData ? detailsData.item_info.after_sale_problem ? detailsData.item_info.after_sale_problem === 'add_goods' ? '补发' : detailsData.item_info.after_sale_problem === 'return_goods' ? '退货' : detailsData.item_info.after_sale_problem === 'return_money' ? '退款' : '换货' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>采购到货周期：</span>
                <span  style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.arrive_cycle ?  detailsData.item_info.arrive_cycle + '天' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>是否独家销售：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.is_one_sale === 1 ? '是' : '否'  : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>市场推广费用：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                  {detailsData ? detailsData.item_info.promote_charge ? detailsData.item_info.promote_charge + '元' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>返利产生节点：</span>
                <span style={{ width: 244, marginRight: '0px', display: 'inline-block' }} >
                {detailsData ? detailsData.item_info.rebate_note ? detailsData.item_info.rebate_note === 'stock' ? '进货' : '回款' : '-' : '-'}
                </span>
              </section>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default CooperationPolicy



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/nonmedicaldevicesdetails/cooperation-policy.js